<div class="flex" (click)="onClickFilter()">
  @switch (dataBskFilter.visibility) {
    @case (0) {
      <i class="material-icons md-18 nopad">search</i>
    }
    @case (1) {
      <i class="material-icons md-18 nopad">group</i>
    }
    @case (2) {
      <i class="material-icons md-18 nopad">person</i>
    }
  }
  <div class="col-12 md:col-11 lg:col-11">
    <div class="title cursorPointer">
      {{dataBskFilter.label}}
    </div>
    <div class="cursorPointer">
      {{dataBskFilter.description}}
    </div>
  </div>
</div>

